// extracted by mini-css-extract-plugin
module.exports = {"list":"ExternalUser_list__3MyIf","label":"ExternalUser_label__1SAIl","name":"ExternalUser_name__3MJqW","action":"ExternalUser_action__ULTs0"};